// extracted by mini-css-extract-plugin
module.exports = {"container":"kn-z","recos":"ln-z","productCardOverride":"mn-z"};